var map = {
	"./australian-shepherd-1.jpeg": 13651,
	"./australian-shepherd-2.jpeg": 14086,
	"./australian-shepherd-3.jpeg": 27949,
	"./australian-shepherd-4.jpeg": 90808,
	"./australian-shepherd.jpeg": 44657,
	"./basset-hound-1.jpeg": 41708,
	"./basset-hound-2.jpeg": 44589,
	"./basset-hound-3.jpeg": 89574,
	"./basset-hound-4.jpeg": 62063,
	"./basset-hound.jpeg": 74862,
	"./beagle-1.jpeg": 33087,
	"./beagle-2.jpeg": 75170,
	"./beagle-3.jpeg": 19177,
	"./beagle-4.jpeg": 74012,
	"./beagle.jpeg": 18805,
	"./belgian-malinois-1.jpeg": 93500,
	"./belgian-malinois-2.jpeg": 93373,
	"./belgian-malinois-3.jpeg": 88758,
	"./belgian-malinois-4.jpeg": 48351,
	"./belgian-malinois.jpeg": 29726,
	"./bernedoodle-1.jpeg": 21786,
	"./bernedoodle-2.jpeg": 82775,
	"./bernedoodle-3.jpeg": 83200,
	"./bernedoodle-4.jpeg": 2325,
	"./bernedoodle.jpeg": 47812,
	"./bernese-mountain-dog-1.jpeg": 64190,
	"./bernese-mountain-dog-2.jpeg": 10923,
	"./bernese-mountain-dog-3.jpeg": 75716,
	"./bernese-mountain-dog-4.jpeg": 37009,
	"./bernese-mountain-dog.jpeg": 36064,
	"./bichon-frise-1.jpeg": 600,
	"./bichon-frise-2.jpeg": 78745,
	"./bichon-frise-3.jpeg": 47890,
	"./bichon-frise-4.jpeg": 47123,
	"./bichon-frise.jpeg": 97458,
	"./border-collie-1.jpeg": 62210,
	"./border-collie-2.jpeg": 89503,
	"./border-collie-3.jpeg": 58984,
	"./border-collie-4.jpeg": 87549,
	"./border-collie.jpeg": 85756,
	"./boston-terrier-1.jpeg": 7884,
	"./boston-terrier-2.jpeg": 37485,
	"./boston-terrier-3.jpeg": 7270,
	"./boston-terrier-4.jpeg": 94479,
	"./boston-terrier.jpeg": 63342,
	"./boxer-1.jpeg": 32553,
	"./boxer-2.jpeg": 7112,
	"./boxer-3.jpeg": 53983,
	"./boxer-4.jpeg": 70710,
	"./boxer.jpeg": 81431,
	"./bulldog-1.jpeg": 21966,
	"./bulldog-2.jpeg": 51611,
	"./bulldog-3.jpeg": 63092,
	"./bulldog-4.jpeg": 81729,
	"./bulldog.jpeg": 57296,
	"./cane-corso-1.jpeg": 85807,
	"./cane-corso-2.jpeg": 92210,
	"./cane-corso-3.jpeg": 64409,
	"./cane-corso-4.jpeg": 72012,
	"./cane-corso.jpeg": 68741,
	"./cavalier-king-charles-spaniel-1.jpeg": 34538,
	"./cavalier-king-charles-spaniel-2.jpeg": 65095,
	"./cavalier-king-charles-spaniel-3.jpeg": 37392,
	"./cavalier-king-charles-spaniel-4.jpeg": 58373,
	"./cavalier-king-charles-spaniel.jpeg": 15732,
	"./cavapoo-1.jpeg": 64242,
	"./cavapoo-2.jpeg": 62671,
	"./cavapoo-3.jpeg": 51128,
	"./cavapoo-4.jpeg": 173,
	"./cavapoo.jpeg": 35660,
	"./chihuahua-1.jpeg": 22193,
	"./chihuahua-2.jpeg": 4528,
	"./chihuahua-3.jpeg": 61703,
	"./chihuahua-4.jpeg": 31582,
	"./chihuahua.jpeg": 34735,
	"./cocker-spaniel-1.jpeg": 51469,
	"./cocker-spaniel-2.jpeg": 48588,
	"./cocker-spaniel-3.jpeg": 10867,
	"./cocker-spaniel-4.jpeg": 11634,
	"./cocker-spaniel.jpeg": 43411,
	"./dachshund-1.jpeg": 1939,
	"./dachshund-2.jpeg": 25670,
	"./dachshund-3.jpeg": 42541,
	"./dachshund-4.jpeg": 2392,
	"./dachshund.jpeg": 19537,
	"./doberman-pinscher-1.jpeg": 83530,
	"./doberman-pinscher-2.jpeg": 75463,
	"./doberman-pinscher-3.jpeg": 9680,
	"./doberman-pinscher-4.jpeg": 38117,
	"./doberman-pinscher.jpeg": 90964,
	"./french-bulldog-1.jpeg": 32141,
	"./french-bulldog-2.jpeg": 2540,
	"./french-bulldog-3.jpeg": 17843,
	"./french-bulldog-4.jpeg": 91986,
	"./french-bulldog.jpg": 88710,
	"./german-shepherd-dog-1.jpeg": 59286,
	"./german-shepherd-dog-2.jpeg": 54000,
	"./german-shepherd-dog-3.jpeg": 71356,
	"./german-shepherd-dog-4.jpeg": 21129,
	"./german-shepherd-dog.jpeg": 74184,
	"./golden-retriever-1.jpeg": 82455,
	"./golden-retriever-2.jpeg": 44762,
	"./golden-retriever-3.jpeg": 11457,
	"./golden-retriever-4.jpeg": 9172,
	"./golden-retriever.jpeg": 61565,
	"./goldendoodle-1.jpeg": 71329,
	"./goldendoodle-2.jpeg": 69056,
	"./goldendoodle-3.jpeg": 52279,
	"./goldendoodle-4.jpeg": 27918,
	"./goldendoodle.jpeg": 73791,
	"./great-dane-1.jpeg": 38879,
	"./great-dane-2.jpeg": 31362,
	"./great-dane-3.jpeg": 68041,
	"./great-dane-4.jpeg": 10428,
	"./great-dane.jpeg": 57141,
	"./havanese-1.jpeg": 40802,
	"./havanese-2.jpeg": 91391,
	"./havanese-3.jpeg": 53800,
	"./havanese-4.jpeg": 36413,
	"./havanese.jpeg": 10652,
	"./labrador-retriever-1.jpeg": 31713,
	"./labrador-retriever-2.jpeg": 29440,
	"./labrador-retriever-3.jpeg": 12663,
	"./labrador-retriever-4.jpeg": 88302,
	"./labrador-retriever.jpeg": 27455,
	"./maltese-1.jpeg": 85614,
	"./maltese-2.jpeg": 29659,
	"./maltese-3.jpeg": 66324,
	"./maltese-4.jpeg": 54209,
	"./maltese.jpeg": 19184,
	"./maltipoo-1.jpeg": 44688,
	"./maltipoo-2.jpeg": 2033,
	"./maltipoo-3.jpeg": 18538,
	"./maltipoo-4.jpeg": 18347,
	"./maltipoo.jpeg": 58586,
	"./miniature-schnauzer-1.jpeg": 98641,
	"./miniature-schnauzer-2.jpeg": 41296,
	"./miniature-schnauzer-3.jpeg": 7079,
	"./miniature-schnauzer-4.jpeg": 77246,
	"./miniature-schnauzer.jpeg": 2031,
	"./pembroke-welsh-corgi-1.jpeg": 2321,
	"./pembroke-welsh-corgi-2.jpeg": 44976,
	"./pembroke-welsh-corgi-3.jpeg": 10759,
	"./pembroke-welsh-corgi-4.jpeg": 64574,
	"./pembroke-welsh-corgi.jpeg": 48412,
	"./pomeranian-1.jpeg": 82957,
	"./pomeranian-2.jpeg": 96428,
	"./pomeranian-3.jpeg": 42355,
	"./pomeranian-4.jpeg": 16626,
	"./pomeranian.jpeg": 88211,
	"./poodle-1.jpeg": 7480,
	"./poodle-2.jpeg": 46041,
	"./poodle-3.jpeg": 20818,
	"./poodle-4.jpeg": 30323,
	"./poodle.jpeg": 7026,
	"./portuguese-water-dog-1.jpeg": 42605,
	"./portuguese-water-dog-2.jpeg": 56076,
	"./portuguese-water-dog-3.jpeg": 32755,
	"./portuguese-water-dog-4.jpeg": 6674,
	"./portuguese-water-dog.jpeg": 52979,
	"./pug-1.jpeg": 96819,
	"./pug-2.jpeg": 20550,
	"./pug-3.jpeg": 37421,
	"./pug-4.jpeg": 97272,
	"./pug.jpeg": 47217,
	"./rottweiler-1.jpeg": 52604,
	"./rottweiler-2.jpeg": 52477,
	"./rottweiler-3.jpeg": 64214,
	"./rottweiler-4.jpeg": 7455,
	"./rottweiler.jpeg": 87774,
	"./shih-tzu-1.jpeg": 49483,
	"./shih-tzu-2.jpeg": 38174,
	"./shih-tzu-3.jpeg": 73733,
	"./shih-tzu-4.jpeg": 59696,
	"./shih-tzu.jpeg": 1849,
	"./siberian-husky-1.jpeg": 3815,
	"./siberian-husky-2.jpeg": 56906,
	"./siberian-husky-3.jpeg": 68529,
	"./siberian-husky-4.jpeg": 7236,
	"./siberian-husky.jpeg": 1485,
	"./toy-australian-shepherd-1.jpeg": 99690,
	"./toy-australian-shepherd-2.jpeg": 46599,
	"./toy-australian-shepherd-3.jpeg": 2544,
	"./toy-australian-shepherd-4.jpeg": 39877,
	"./toy-australian-shepherd.jpeg": 81556,
	"./yorkshire-terrier-1.jpeg": 49593,
	"./yorkshire-terrier-2.jpeg": 19928,
	"./yorkshire-terrier-3.jpeg": 70991,
	"./yorkshire-terrier-4.jpeg": 26854,
	"./yorkshire-terrier.jpeg": 5812,
	"src/assets/homepage/breeds/australian-shepherd-1.jpeg": 13651,
	"src/assets/homepage/breeds/australian-shepherd-2.jpeg": 14086,
	"src/assets/homepage/breeds/australian-shepherd-3.jpeg": 27949,
	"src/assets/homepage/breeds/australian-shepherd-4.jpeg": 90808,
	"src/assets/homepage/breeds/australian-shepherd.jpeg": 44657,
	"src/assets/homepage/breeds/basset-hound-1.jpeg": 41708,
	"src/assets/homepage/breeds/basset-hound-2.jpeg": 44589,
	"src/assets/homepage/breeds/basset-hound-3.jpeg": 89574,
	"src/assets/homepage/breeds/basset-hound-4.jpeg": 62063,
	"src/assets/homepage/breeds/basset-hound.jpeg": 74862,
	"src/assets/homepage/breeds/beagle-1.jpeg": 33087,
	"src/assets/homepage/breeds/beagle-2.jpeg": 75170,
	"src/assets/homepage/breeds/beagle-3.jpeg": 19177,
	"src/assets/homepage/breeds/beagle-4.jpeg": 74012,
	"src/assets/homepage/breeds/beagle.jpeg": 18805,
	"src/assets/homepage/breeds/belgian-malinois-1.jpeg": 93500,
	"src/assets/homepage/breeds/belgian-malinois-2.jpeg": 93373,
	"src/assets/homepage/breeds/belgian-malinois-3.jpeg": 88758,
	"src/assets/homepage/breeds/belgian-malinois-4.jpeg": 48351,
	"src/assets/homepage/breeds/belgian-malinois.jpeg": 29726,
	"src/assets/homepage/breeds/bernedoodle-1.jpeg": 21786,
	"src/assets/homepage/breeds/bernedoodle-2.jpeg": 82775,
	"src/assets/homepage/breeds/bernedoodle-3.jpeg": 83200,
	"src/assets/homepage/breeds/bernedoodle-4.jpeg": 2325,
	"src/assets/homepage/breeds/bernedoodle.jpeg": 47812,
	"src/assets/homepage/breeds/bernese-mountain-dog-1.jpeg": 64190,
	"src/assets/homepage/breeds/bernese-mountain-dog-2.jpeg": 10923,
	"src/assets/homepage/breeds/bernese-mountain-dog-3.jpeg": 75716,
	"src/assets/homepage/breeds/bernese-mountain-dog-4.jpeg": 37009,
	"src/assets/homepage/breeds/bernese-mountain-dog.jpeg": 36064,
	"src/assets/homepage/breeds/bichon-frise-1.jpeg": 600,
	"src/assets/homepage/breeds/bichon-frise-2.jpeg": 78745,
	"src/assets/homepage/breeds/bichon-frise-3.jpeg": 47890,
	"src/assets/homepage/breeds/bichon-frise-4.jpeg": 47123,
	"src/assets/homepage/breeds/bichon-frise.jpeg": 97458,
	"src/assets/homepage/breeds/border-collie-1.jpeg": 62210,
	"src/assets/homepage/breeds/border-collie-2.jpeg": 89503,
	"src/assets/homepage/breeds/border-collie-3.jpeg": 58984,
	"src/assets/homepage/breeds/border-collie-4.jpeg": 87549,
	"src/assets/homepage/breeds/border-collie.jpeg": 85756,
	"src/assets/homepage/breeds/boston-terrier-1.jpeg": 7884,
	"src/assets/homepage/breeds/boston-terrier-2.jpeg": 37485,
	"src/assets/homepage/breeds/boston-terrier-3.jpeg": 7270,
	"src/assets/homepage/breeds/boston-terrier-4.jpeg": 94479,
	"src/assets/homepage/breeds/boston-terrier.jpeg": 63342,
	"src/assets/homepage/breeds/boxer-1.jpeg": 32553,
	"src/assets/homepage/breeds/boxer-2.jpeg": 7112,
	"src/assets/homepage/breeds/boxer-3.jpeg": 53983,
	"src/assets/homepage/breeds/boxer-4.jpeg": 70710,
	"src/assets/homepage/breeds/boxer.jpeg": 81431,
	"src/assets/homepage/breeds/bulldog-1.jpeg": 21966,
	"src/assets/homepage/breeds/bulldog-2.jpeg": 51611,
	"src/assets/homepage/breeds/bulldog-3.jpeg": 63092,
	"src/assets/homepage/breeds/bulldog-4.jpeg": 81729,
	"src/assets/homepage/breeds/bulldog.jpeg": 57296,
	"src/assets/homepage/breeds/cane-corso-1.jpeg": 85807,
	"src/assets/homepage/breeds/cane-corso-2.jpeg": 92210,
	"src/assets/homepage/breeds/cane-corso-3.jpeg": 64409,
	"src/assets/homepage/breeds/cane-corso-4.jpeg": 72012,
	"src/assets/homepage/breeds/cane-corso.jpeg": 68741,
	"src/assets/homepage/breeds/cavalier-king-charles-spaniel-1.jpeg": 34538,
	"src/assets/homepage/breeds/cavalier-king-charles-spaniel-2.jpeg": 65095,
	"src/assets/homepage/breeds/cavalier-king-charles-spaniel-3.jpeg": 37392,
	"src/assets/homepage/breeds/cavalier-king-charles-spaniel-4.jpeg": 58373,
	"src/assets/homepage/breeds/cavalier-king-charles-spaniel.jpeg": 15732,
	"src/assets/homepage/breeds/cavapoo-1.jpeg": 64242,
	"src/assets/homepage/breeds/cavapoo-2.jpeg": 62671,
	"src/assets/homepage/breeds/cavapoo-3.jpeg": 51128,
	"src/assets/homepage/breeds/cavapoo-4.jpeg": 173,
	"src/assets/homepage/breeds/cavapoo.jpeg": 35660,
	"src/assets/homepage/breeds/chihuahua-1.jpeg": 22193,
	"src/assets/homepage/breeds/chihuahua-2.jpeg": 4528,
	"src/assets/homepage/breeds/chihuahua-3.jpeg": 61703,
	"src/assets/homepage/breeds/chihuahua-4.jpeg": 31582,
	"src/assets/homepage/breeds/chihuahua.jpeg": 34735,
	"src/assets/homepage/breeds/cocker-spaniel-1.jpeg": 51469,
	"src/assets/homepage/breeds/cocker-spaniel-2.jpeg": 48588,
	"src/assets/homepage/breeds/cocker-spaniel-3.jpeg": 10867,
	"src/assets/homepage/breeds/cocker-spaniel-4.jpeg": 11634,
	"src/assets/homepage/breeds/cocker-spaniel.jpeg": 43411,
	"src/assets/homepage/breeds/dachshund-1.jpeg": 1939,
	"src/assets/homepage/breeds/dachshund-2.jpeg": 25670,
	"src/assets/homepage/breeds/dachshund-3.jpeg": 42541,
	"src/assets/homepage/breeds/dachshund-4.jpeg": 2392,
	"src/assets/homepage/breeds/dachshund.jpeg": 19537,
	"src/assets/homepage/breeds/doberman-pinscher-1.jpeg": 83530,
	"src/assets/homepage/breeds/doberman-pinscher-2.jpeg": 75463,
	"src/assets/homepage/breeds/doberman-pinscher-3.jpeg": 9680,
	"src/assets/homepage/breeds/doberman-pinscher-4.jpeg": 38117,
	"src/assets/homepage/breeds/doberman-pinscher.jpeg": 90964,
	"src/assets/homepage/breeds/french-bulldog-1.jpeg": 32141,
	"src/assets/homepage/breeds/french-bulldog-2.jpeg": 2540,
	"src/assets/homepage/breeds/french-bulldog-3.jpeg": 17843,
	"src/assets/homepage/breeds/french-bulldog-4.jpeg": 91986,
	"src/assets/homepage/breeds/french-bulldog.jpg": 88710,
	"src/assets/homepage/breeds/german-shepherd-dog-1.jpeg": 59286,
	"src/assets/homepage/breeds/german-shepherd-dog-2.jpeg": 54000,
	"src/assets/homepage/breeds/german-shepherd-dog-3.jpeg": 71356,
	"src/assets/homepage/breeds/german-shepherd-dog-4.jpeg": 21129,
	"src/assets/homepage/breeds/german-shepherd-dog.jpeg": 74184,
	"src/assets/homepage/breeds/golden-retriever-1.jpeg": 82455,
	"src/assets/homepage/breeds/golden-retriever-2.jpeg": 44762,
	"src/assets/homepage/breeds/golden-retriever-3.jpeg": 11457,
	"src/assets/homepage/breeds/golden-retriever-4.jpeg": 9172,
	"src/assets/homepage/breeds/golden-retriever.jpeg": 61565,
	"src/assets/homepage/breeds/goldendoodle-1.jpeg": 71329,
	"src/assets/homepage/breeds/goldendoodle-2.jpeg": 69056,
	"src/assets/homepage/breeds/goldendoodle-3.jpeg": 52279,
	"src/assets/homepage/breeds/goldendoodle-4.jpeg": 27918,
	"src/assets/homepage/breeds/goldendoodle.jpeg": 73791,
	"src/assets/homepage/breeds/great-dane-1.jpeg": 38879,
	"src/assets/homepage/breeds/great-dane-2.jpeg": 31362,
	"src/assets/homepage/breeds/great-dane-3.jpeg": 68041,
	"src/assets/homepage/breeds/great-dane-4.jpeg": 10428,
	"src/assets/homepage/breeds/great-dane.jpeg": 57141,
	"src/assets/homepage/breeds/havanese-1.jpeg": 40802,
	"src/assets/homepage/breeds/havanese-2.jpeg": 91391,
	"src/assets/homepage/breeds/havanese-3.jpeg": 53800,
	"src/assets/homepage/breeds/havanese-4.jpeg": 36413,
	"src/assets/homepage/breeds/havanese.jpeg": 10652,
	"src/assets/homepage/breeds/labrador-retriever-1.jpeg": 31713,
	"src/assets/homepage/breeds/labrador-retriever-2.jpeg": 29440,
	"src/assets/homepage/breeds/labrador-retriever-3.jpeg": 12663,
	"src/assets/homepage/breeds/labrador-retriever-4.jpeg": 88302,
	"src/assets/homepage/breeds/labrador-retriever.jpeg": 27455,
	"src/assets/homepage/breeds/maltese-1.jpeg": 85614,
	"src/assets/homepage/breeds/maltese-2.jpeg": 29659,
	"src/assets/homepage/breeds/maltese-3.jpeg": 66324,
	"src/assets/homepage/breeds/maltese-4.jpeg": 54209,
	"src/assets/homepage/breeds/maltese.jpeg": 19184,
	"src/assets/homepage/breeds/maltipoo-1.jpeg": 44688,
	"src/assets/homepage/breeds/maltipoo-2.jpeg": 2033,
	"src/assets/homepage/breeds/maltipoo-3.jpeg": 18538,
	"src/assets/homepage/breeds/maltipoo-4.jpeg": 18347,
	"src/assets/homepage/breeds/maltipoo.jpeg": 58586,
	"src/assets/homepage/breeds/miniature-schnauzer-1.jpeg": 98641,
	"src/assets/homepage/breeds/miniature-schnauzer-2.jpeg": 41296,
	"src/assets/homepage/breeds/miniature-schnauzer-3.jpeg": 7079,
	"src/assets/homepage/breeds/miniature-schnauzer-4.jpeg": 77246,
	"src/assets/homepage/breeds/miniature-schnauzer.jpeg": 2031,
	"src/assets/homepage/breeds/pembroke-welsh-corgi-1.jpeg": 2321,
	"src/assets/homepage/breeds/pembroke-welsh-corgi-2.jpeg": 44976,
	"src/assets/homepage/breeds/pembroke-welsh-corgi-3.jpeg": 10759,
	"src/assets/homepage/breeds/pembroke-welsh-corgi-4.jpeg": 64574,
	"src/assets/homepage/breeds/pembroke-welsh-corgi.jpeg": 48412,
	"src/assets/homepage/breeds/pomeranian-1.jpeg": 82957,
	"src/assets/homepage/breeds/pomeranian-2.jpeg": 96428,
	"src/assets/homepage/breeds/pomeranian-3.jpeg": 42355,
	"src/assets/homepage/breeds/pomeranian-4.jpeg": 16626,
	"src/assets/homepage/breeds/pomeranian.jpeg": 88211,
	"src/assets/homepage/breeds/poodle-1.jpeg": 7480,
	"src/assets/homepage/breeds/poodle-2.jpeg": 46041,
	"src/assets/homepage/breeds/poodle-3.jpeg": 20818,
	"src/assets/homepage/breeds/poodle-4.jpeg": 30323,
	"src/assets/homepage/breeds/poodle.jpeg": 7026,
	"src/assets/homepage/breeds/portuguese-water-dog-1.jpeg": 42605,
	"src/assets/homepage/breeds/portuguese-water-dog-2.jpeg": 56076,
	"src/assets/homepage/breeds/portuguese-water-dog-3.jpeg": 32755,
	"src/assets/homepage/breeds/portuguese-water-dog-4.jpeg": 6674,
	"src/assets/homepage/breeds/portuguese-water-dog.jpeg": 52979,
	"src/assets/homepage/breeds/pug-1.jpeg": 96819,
	"src/assets/homepage/breeds/pug-2.jpeg": 20550,
	"src/assets/homepage/breeds/pug-3.jpeg": 37421,
	"src/assets/homepage/breeds/pug-4.jpeg": 97272,
	"src/assets/homepage/breeds/pug.jpeg": 47217,
	"src/assets/homepage/breeds/rottweiler-1.jpeg": 52604,
	"src/assets/homepage/breeds/rottweiler-2.jpeg": 52477,
	"src/assets/homepage/breeds/rottweiler-3.jpeg": 64214,
	"src/assets/homepage/breeds/rottweiler-4.jpeg": 7455,
	"src/assets/homepage/breeds/rottweiler.jpeg": 87774,
	"src/assets/homepage/breeds/shih-tzu-1.jpeg": 49483,
	"src/assets/homepage/breeds/shih-tzu-2.jpeg": 38174,
	"src/assets/homepage/breeds/shih-tzu-3.jpeg": 73733,
	"src/assets/homepage/breeds/shih-tzu-4.jpeg": 59696,
	"src/assets/homepage/breeds/shih-tzu.jpeg": 1849,
	"src/assets/homepage/breeds/siberian-husky-1.jpeg": 3815,
	"src/assets/homepage/breeds/siberian-husky-2.jpeg": 56906,
	"src/assets/homepage/breeds/siberian-husky-3.jpeg": 68529,
	"src/assets/homepage/breeds/siberian-husky-4.jpeg": 7236,
	"src/assets/homepage/breeds/siberian-husky.jpeg": 1485,
	"src/assets/homepage/breeds/toy-australian-shepherd-1.jpeg": 99690,
	"src/assets/homepage/breeds/toy-australian-shepherd-2.jpeg": 46599,
	"src/assets/homepage/breeds/toy-australian-shepherd-3.jpeg": 2544,
	"src/assets/homepage/breeds/toy-australian-shepherd-4.jpeg": 39877,
	"src/assets/homepage/breeds/toy-australian-shepherd.jpeg": 81556,
	"src/assets/homepage/breeds/yorkshire-terrier-1.jpeg": 49593,
	"src/assets/homepage/breeds/yorkshire-terrier-2.jpeg": 19928,
	"src/assets/homepage/breeds/yorkshire-terrier-3.jpeg": 70991,
	"src/assets/homepage/breeds/yorkshire-terrier-4.jpeg": 26854,
	"src/assets/homepage/breeds/yorkshire-terrier.jpeg": 5812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52394;